/* 我的行程 / 行程查询页（#trip，magic-link 模式）
 * 由 nav.js 在 trip 路由 renderFramed 后调用 window.LN_TRIP.load(el, lang)。
 * 客人打开专属链接 (…/?t=TOKEN#trip 或 …/#trip?t=TOKEN)，凭 token 从你后端只读接口取自己的行程。
 * ⚠ 安全在后端：token 必须随机不可猜、可过期/吊销；接口按 token 授权，不要在前端放共享密钥
 *   （若接口需密钥，走 Cloudflare Worker 代理）。接后端只改下方 CONFIG。*/
window.LN_TRIP = (function () {
  'use strict';

  /* ============================ 配置区（接后端只改这里）============================ */
  var CONFIG = {
    // 你的“按 token 查客人行程”只读接口。留空('')时显示【演示数据】，方便先看设计。
    ENDPOINT: '',
    TOKEN_PARAM: 't',
    // 如何带上 token 去请求。默认 GET，token 作 query。可改成 header / POST body。
    buildRequest: function (endpoint, token) {
      var sep = endpoint.indexOf('?') >= 0 ? '&' : '?';
      return { url: endpoint + sep + 'token=' + encodeURIComponent(token), options: { method: 'GET', headers: { 'Accept': 'application/json' } } };
    },
    // 把你后端返回的 JSON 映射成下面 renderItinerary 用的规范结构。默认原样。
    mapResponse: function (json) { return json; },
    // 判定“查到了”。默认返回体里有 tour/booking_ref 即算查到；404/空 => 未找到。
    isFound: function (data) { return !!(data && (data.booking_ref || data.tour)); },
    WA: '8613316423196'
  };

  /* ============================ 演示数据（ENDPOINT 为空时用；接后端后不再出现）============================ */
  var MOCK = {
    booking_ref: 'LJ-2026-0042', status: 'deposit_paid',
    traveler: { name: 'Alex Chen' },
    tour: { title: '漓遇阳朔 · 4 天 3 晚', title_en: 'Liyu Yangshuo · 4-Day Journey' },
    dates: '2026-10-12 → 2026-10-15', pax: '2 位成人',
    days: [
      { day: 'D1', title: '初见桂林 · 静谧抵达', desc: '专车接机入住天龙湾曼悦,傍晚两江四湖夜景。', stay: '宿 · 桂林' },
      { day: 'D2', title: '动感漓江 · 瀑布画卷', desc: '古东森林瀑布 + 漓江竹筏(杨堤—兴坪)+ 兴坪古镇。', stay: '宿 · 阳朔' },
      { day: 'D3', title: '艺韵田园 · 溶洞西街', desc: '银子岩 + 十里画廊骑行 + 阳朔西街夜色。', stay: '宿 · 阳朔' },
      { day: 'D4', title: '城市脉搏 · 深度回味', desc: '象鼻山 · 南溪山摩崖石刻,专车送团。', stay: '离 · 桂林' }
    ],
    payment: { currency: 'USD', total: '1,180', deposit: '354', balance: '826', balance_due: '2026-09-28', paid: true },
    documents: [{ label: '形式发票 Proforma Invoice', url: '' }],
    planner: { name: 'Lily', whatsapp: '8613316423196' },
    notes: '出发前 14 天付清尾款;行程单与出行手册将于付清后发送。',
    _demo: true
  };

  /* ============================ 四语 ============================ */
  var L = {
    cn: { eyebrow: '我的行程', ref: '预订号', traveler: '客人', dates: '出行日期', pax: '人数',
      itin: '行程安排', pay: '付款', total: '总额', deposit: '定金', balance: '尾款', due: '尾款到期',
      docs: '相关文档', planner: '您的专属规划师', chat: 'WhatsApp 联系', loading: '正在读取您的行程…',
      noToken: '请通过我们发送给您的专属链接打开本页,以查看您的行程。', notFound: '未找到对应行程,链接可能已过期。请联系您的规划师。',
      err: '读取失败,请稍后重试或联系我们。', demo: '演示数据 · 接入后端后显示真实行程', paidTag: '已付定金',
      st: { inquiry: '询价中', confirmed: '已确认', deposit_paid: '已付定金', paid: '已付清', in_progress: '行程中', completed: '已完成' } },
    en: { eyebrow: 'MY TRIP', ref: 'Booking', traveler: 'Traveler', dates: 'Travel dates', pax: 'Travelers',
      itin: 'Itinerary', pay: 'Payment', total: 'Total', deposit: 'Deposit', balance: 'Balance', due: 'Balance due',
      docs: 'Documents', planner: 'Your travel designer', chat: 'Chat on WhatsApp', loading: 'Loading your trip…',
      noToken: 'Please open this page from the personal link we sent you to view your trip.', notFound: 'No trip found — the link may have expired. Please contact your designer.',
      err: 'Could not load. Please try again later or contact us.', demo: 'Demo data · real trip shows once the backend is connected', paidTag: 'Deposit paid',
      st: { inquiry: 'Inquiry', confirmed: 'Confirmed', deposit_paid: 'Deposit paid', paid: 'Paid in full', in_progress: 'In progress', completed: 'Completed' } },
    ja: { eyebrow: 'マイ旅程', ref: '予約番号', traveler: 'お客様', dates: '旅行日程', pax: '人数',
      itin: '旅程', pay: 'お支払い', total: '合計', deposit: '手付金', balance: '残金', due: '残金期限',
      docs: '書類', planner: '担当プランナー', chat: 'WhatsAppで連絡', loading: '旅程を読み込み中…',
      noToken: 'お送りした専用リンクからこのページを開いてください。', notFound: '旅程が見つかりません。リンクの有効期限が切れている可能性があります。担当者にご連絡ください。',
      err: '読み込みに失敗しました。後ほど再試行いただくかご連絡ください。', demo: 'デモデータ · バックエンド接続後に実データを表示', paidTag: '手付金入金済',
      st: { inquiry: '見積中', confirmed: '確定', deposit_paid: '手付金入金済', paid: '全額入金済', in_progress: '催行中', completed: '完了' } },
    ko: { eyebrow: '내 여정', ref: '예약번호', traveler: '고객', dates: '여행 일정', pax: '인원',
      itin: '일정', pay: '결제', total: '총액', deposit: '예약금', balance: '잔금', due: '잔금 기한',
      docs: '문서', planner: '전담 플래너', chat: 'WhatsApp 문의', loading: '여정을 불러오는 중…',
      noToken: '보내드린 전용 링크로 이 페이지를 열어 여정을 확인하세요.', notFound: '여정을 찾을 수 없습니다. 링크가 만료되었을 수 있습니다. 플래너에게 문의하세요.',
      err: '불러오기에 실패했습니다. 나중에 다시 시도하거나 문의해 주세요.', demo: '데모 데이터 · 백엔드 연결 후 실제 여정 표시', paidTag: '예약금 결제됨',
      st: { inquiry: '문의', confirmed: '확정', deposit_paid: '예약금 결제됨', paid: '완납', in_progress: '진행 중', completed: '완료' } }
  };
  var FONTS = {
    en: { serif: "'Playfair Display',Georgia,serif", sans: "system-ui,-apple-system,sans-serif" },
    cn: { serif: "'Noto Serif SC',serif", sans: "'Noto Sans SC',system-ui,sans-serif" },
    ja: { serif: "'Noto Serif JP',serif", sans: "'Noto Sans JP',system-ui,sans-serif" },
    ko: { serif: "'Noto Serif KR',serif", sans: "'Noto Sans KR',system-ui,sans-serif" }
  };
  var STCOLOR = { inquiry: '#8A7F76', confirmed: '#2E6E64', deposit_paid: '#C9A86A', paid: '#2E6E64', in_progress: '#2E6E64', completed: '#8A7F76' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function getToken() {
    try {
      var s = new URLSearchParams(location.search).get(CONFIG.TOKEN_PARAM); if (s) return s;
      var h = (location.hash || '').indexOf('?'); if (h >= 0) return new URLSearchParams(location.hash.slice(h + 1)).get(CONFIG.TOKEN_PARAM) || '';
    } catch (e) {}
    return '';
  }

  function render(lang) {
    var f = FONTS[lang] || FONTS.en, t = L[lang] || L.en;
    return '<section style="background:#FAF7F2;min-height:60vh;padding:64px 24px">' +
      '<div style="max-width:920px;margin:0 auto">' +
        '<div style="font:700 12px/1 ' + f.sans + ';letter-spacing:4px;color:#B01722">' + t.eyebrow + '</div>' +
        '<div data-ln-trip-root style="margin-top:24px">' +
          '<div style="font:400 15px/1.7 ' + f.sans + ';color:#6B625B;padding:40px 0">' + t.loading + '</div>' +
        '</div>' +
      '</div>' +
    '</section>';
  }

  function stateMsg(f, msg) {
    return '<div style="background:#FFFFFF;border:1px solid #EAE2D8;border-radius:16px;padding:34px 30px">' +
      '<div style="font:400 15px/1.8 ' + f.sans + ';color:#4A423D">' + esc(msg) + '</div>' +
      '<a href="https://wa.me/' + CONFIG.WA + '" target="_blank" rel="noopener" style="display:inline-block;margin-top:18px;background:#231F1D;color:#fff;font:700 14px/1 ' + f.sans + ';padding:13px 22px;border-radius:9999px;text-decoration:none">WhatsApp</a>' +
    '</div>';
  }

  function renderItinerary(root, d, lang) {
    var f = FONTS[lang] || FONTS.en, t = L[lang] || L.en;
    var title = (lang !== 'cn' && d.tour && d.tour.title_en) ? d.tour.title_en : (d.tour ? d.tour.title : '');
    var stColor = STCOLOR[d.status] || '#8A7F76';
    var stLabel = (t.st[d.status]) || d.status || '';
    var html = '';
    if (d._demo) html += '<div style="background:#FFF6E5;border:1px solid #F0D9A8;border-radius:10px;padding:9px 14px;font:600 12px/1.5 ' + f.sans + ';color:#8A6D2F;margin-bottom:18px">' + t.demo + '</div>';

    // 概要卡
    html += '<div style="background:#231F1D;border-radius:18px;padding:30px 32px;color:#fff">' +
      '<div style="display:flex;flex-wrap:wrap;gap:12px;align-items:center;justify-content:space-between">' +
        '<div style="font:700 26px/1.2 ' + f.serif + ';color:#fff">' + esc(title) + '</div>' +
        '<div style="font:700 12px/1 ' + f.sans + ';letter-spacing:1px;color:#231F1D;background:' + stColor + ';padding:8px 14px;border-radius:9999px">' + esc(stLabel) + '</div>' +
      '</div>' +
      '<div style="display:flex;flex-wrap:wrap;gap:26px;margin-top:18px">' +
        kv(f, t.ref, d.booking_ref) + kv(f, t.traveler, d.traveler && d.traveler.name) +
        kv(f, t.dates, d.dates) + kv(f, t.pax, d.pax) +
      '</div>' +
    '</div>';

    // 逐日行程
    if (d.days && d.days.length) {
      html += '<div style="font:700 13px/1 ' + f.sans + ';letter-spacing:2px;color:#2E6E64;margin:34px 0 4px">' + t.itin + '</div>' +
        '<div style="display:flex;flex-direction:column;gap:12px;margin-top:14px">' +
        d.days.map(function (x) {
          return '<div style="background:#FFFFFF;border:1px solid #EAE2D8;border-left:3px solid #2E6E64;border-radius:12px;padding:16px 20px">' +
            '<div style="display:flex;gap:12px;align-items:baseline">' +
              '<div style="font:700 13px/1.2 ' + f.sans + ';color:#2E6E64;min-width:34px">' + esc(x.day) + '</div>' +
              '<div style="font:700 16px/1.35 ' + f.serif + ';color:#231F1D">' + esc(x.title) + '</div>' +
            '</div>' +
            (x.desc ? '<div style="font:400 13px/1.7 ' + f.sans + ';color:#6B625B;margin-top:6px;padding-left:46px">' + esc(x.desc) + '</div>' : '') +
            (x.stay ? '<div style="font:700 11px/1.3 ' + f.sans + ';letter-spacing:.5px;color:#8A7F76;margin-top:8px;padding-left:46px">' + esc(x.stay) + '</div>' : '') +
          '</div>';
        }).join('') + '</div>';
    }

    // 付款
    if (d.payment) {
      var p = d.payment, cur = p.currency ? p.currency + ' ' : '';
      html += '<div style="font:700 13px/1 ' + f.sans + ';letter-spacing:2px;color:#2E6E64;margin:34px 0 4px">' + t.pay + '</div>' +
        '<div style="background:#FFFFFF;border:1px solid #EAE2D8;border-radius:14px;padding:20px 24px;margin-top:14px;display:flex;flex-wrap:wrap;gap:26px">' +
          money(f, t.total, cur, p.total) + money(f, t.deposit, cur, p.deposit) +
          money(f, t.balance, cur, p.balance) + (p.balance_due ? kv(f, t.due, p.balance_due, '#231F1D') : '') +
        '</div>';
    }

    // 文档
    if (d.documents && d.documents.length) {
      html += '<div style="font:700 13px/1 ' + f.sans + ';letter-spacing:2px;color:#2E6E64;margin:34px 0 4px">' + t.docs + '</div>' +
        '<div style="display:flex;flex-wrap:wrap;gap:10px;margin-top:14px">' +
        d.documents.map(function (doc) {
          var href = doc.url || '#';
          return '<a href="' + esc(href) + '"' + (doc.url ? ' target="_blank" rel="noopener"' : ' onclick="return false"') + ' style="font:600 13px/1 ' + f.sans + ';color:#231F1D;background:#F1EAE0;border:1px solid #E3DACD;padding:11px 16px;border-radius:9999px;text-decoration:none">📄 ' + esc(doc.label) + '</a>';
        }).join('') + '</div>';
    }

    // 规划师 + WhatsApp
    var wa = (d.planner && d.planner.whatsapp) || CONFIG.WA;
    html += '<div style="margin-top:38px;padding-top:24px;border-top:1px dashed #E3DACD;display:flex;flex-wrap:wrap;gap:14px;align-items:center;justify-content:space-between">' +
      '<div style="font:400 13.5px/1.6 ' + f.sans + ';color:#6B625B">' + t.planner + (d.planner && d.planner.name ? ': <b style="color:#231F1D">' + esc(d.planner.name) + '</b>' : '') +
        (d.notes ? '<div style="margin-top:6px;color:#8A7F76;font-size:12.5px">' + esc(d.notes) + '</div>' : '') + '</div>' +
      '<a href="https://wa.me/' + esc(wa) + '" target="_blank" rel="noopener" style="background:#231F1D;color:#fff;font:700 14px/1 ' + f.sans + ';padding:13px 22px;border-radius:9999px;text-decoration:none">' + t.chat + '</a>' +
    '</div>';

    root.innerHTML = html;
  }
  function kv(f, k, v, vc) {
    if (v == null || v === '') return '';
    return '<div><div style="font:600 11px/1.3 ' + f.sans + ';letter-spacing:.5px;color:#A79C92">' + k + '</div>' +
      '<div style="font:600 14px/1.4 ' + f.sans + ';color:' + (vc || '#F1E7DD') + ';margin-top:3px">' + esc(v) + '</div></div>';
  }
  function money(f, k, cur, v) {
    if (v == null || v === '') return '';
    return '<div><div style="font:600 11px/1.3 ' + f.sans + ';letter-spacing:.5px;color:#8A7F76">' + k + '</div>' +
      '<div style="font:700 16px/1.3 ' + f.sans + ';color:#231F1D;margin-top:3px">' + cur + esc(v) + '</div></div>';
  }

  function load(scope, lang) {
    var root = scope.querySelector('[data-ln-trip-root]');
    if (!root || root.__loaded) return;
    root.__loaded = true;
    var f = FONTS[lang] || FONTS.en, t = L[lang] || L.en;
    var token = getToken();

    // 无接口 -> 演示数据（先看设计）
    if (!CONFIG.ENDPOINT) { renderItinerary(root, MOCK, lang); return; }
    // 有接口但无 token -> 提示用专属链接
    if (!token) { root.innerHTML = stateMsg(f, t.noToken); return; }

    var req = CONFIG.buildRequest(CONFIG.ENDPOINT, token);
    fetch(req.url, req.options).then(function (res) {
      if (res.status === 404) return null;
      if (!res.ok) throw new Error('status ' + res.status);
      return res.json();
    }).then(function (json) {
      if (json == null) { root.innerHTML = stateMsg(f, t.notFound); return; }
      var data = CONFIG.mapResponse(json);
      if (!CONFIG.isFound(data)) { root.innerHTML = stateMsg(f, t.notFound); return; }
      renderItinerary(root, data, lang);
    }).catch(function (err) {
      root.innerHTML = stateMsg(f, t.err);
      try { console.warn('[LN_TRIP] load failed:', err); } catch (e) {}
    });
  }

  return { render: render, load: load, CONFIG: CONFIG };
})();
